// Keep route analytics useful without sending OAuth codes, verification tokens,
// invite codes, shared-link hashes, or arbitrary query parameters to PostHog.
export function sanitizeAnalyticsUrl(value: string): string {
  try {
    const relative = value.startsWith("/");
    const url = new URL(value, "https://placeholder.invalid");
    url.search = "";
    url.hash = "";
    url.pathname = url.pathname
      .replace(/^\/create-account\/invitee\/[^/]+/, "/create-account/invitee/[redacted]")
      .replace(/^\/share\/[^/]+/, "/share/[redacted]");
    return relative ? url.pathname : url.toString();
  } catch {
    // A malformed URL must never preserve a possible token after ? or #.
    return value.split(/[?#]/, 1)[0];
  }
}
